import React from 'react'

import { Icon } from '@fourthwall/components'
import { PlusIcon } from '@fourthwall/icons'

import * as S from './AddPodcastButton.styled'

type AddPodcastProps = {
  onClick: () => void
}

export const AddPodcastButton = ({ onClick }: AddPodcastProps) => (
  <S.Container type="button" onClick={onClick}>
    <Icon component={PlusIcon} height={16} />
    Add new podcast
  </S.Container>
)
